import { blogPosts } from '../pages/blogPosts.js';

const VIDEO_SEARCH_METADATA = {
  'shadow-ai-agent-sprawl-enterprise': {
    title: 'Shadow AI Agent Sprawl: Costs and Governance | BlueBear',
    description: 'See how to inventory shadow AI agents, assign owners, govern tool access, attribute costs, and retire unmanaged enterprise agents safely.',
  },
  'mcp-for-business-leaders': {
    title: 'MCP for Business Leaders: Agent Governance | BlueBear',
    description: 'Learn how business leaders can govern MCP connections, tool access, reusable integrations, credentials, ownership, and audit evidence for AI agents.',
  },
  'ai-agent-control-plane-explained': {
    title: 'What Is an AI Agent Control Plane? | BlueBear',
    description: 'Learn when enterprises need an AI agent control plane for shared identity, policy, tool access, deployment evidence, reliability, and cost controls.',
  },
  'byoc-vs-managed-ai-agent-hosting': {
    title: 'BYOC vs Managed AI Agent Hosting | BlueBear',
    description: 'Compare BYOC and managed AI agent hosting across control, data residency, operations, integrations, scalability, and total cost for each workload.',
  },
  'enterprise-ai-agent-platform-architecture': {
    title: 'Enterprise AI Agent Platform Architecture | BlueBear',
    description: 'Tour a practical enterprise AI agent architecture spanning control, runtime, integrations, governed workspaces, evidence, and operations.',
  },
  'secure-mcp-gateway-production': {
    title: 'Secure MCP Gateway for Production AI Agents | BlueBear',
    description: 'See how a production MCP gateway governs credentials, connections, tool permissions, approval boundaries, policy decisions, and audit receipts.',
  },
  'ai-finops-cost-allocation-agents': {
    title: 'AI FinOps: Cost Allocation for Agents | BlueBear',
    description: 'See how to allocate AI agent costs by tenant and workflow, track retries and usage, enforce budgets, and measure cost per accepted outcome.',
  },
  'pix2code-feedback-driven-ai-model-routing-case-study': {
    title: 'AI Model Routing Case Study: Pix2Code | BlueBear',
    description: 'See how feedback-driven model routing matches each AI task to quality, latency, and cost needs while learning from accepted outcomes.',
  },
};

export const videoPosts = blogPosts.filter((post) => post.videoUrl && post.videoPoster && post.videoTranscript);

export function getVideoPost(slug) {
  return videoPosts.find((post) => post.slug === slug) || null;
}

export function getVideoWatchPath(post) {
  return `/videos/${post.slug}`;
}

export function getVideoSearchMetadata(post) {
  return VIDEO_SEARCH_METADATA[post?.slug] || {
    title: `${post?.title || ''} | BlueBear Video`,
    description: post?.videoCaption || post?.summary || '',
  };
}
